export default function createElement(type, props, ...children) {

    const createTag = (tagName) => {
        const specifies = {
            'svg' : 'http://www.w3.org/2000/svg',
            'g' : 'http://www.w3.org/2000/svg',
            'circle' : 'http://www.w3.org/2000/svg'
        };
        const spec = specifies[tagName];
        if (spec){
            return document.createElementNS(spec, tagName);
        }
        return document.createElement(tagName);
    };

    const elem = createTag(type);

    if (props){
        const aliases = {
            'xmlnsXlink' : 'xmlns:xlink'
        };
        Object.keys(props).forEach(key => {
            elem.setAttribute(aliases[key] || key, props[key]);
        });
    }
    if (children){
        children.forEach(child => {
            if (typeof child === 'string') {
                const textNode = document.createTextNode(child);
                elem.appendChild(textNode);
            }else{
                elem.appendChild(child);
            }
        });
    }
    return elem;
}


// WEBPACK FOOTER //
// ./src/js/utils/createElement.js